import '../../css/Paginador.css';

export default function Paginador({totalRegistros, regPag, pagina, funcion}){
    const cantidadPaginas = Math.ceil(totalRegistros/regPag);
    let rango = [];

    if(cantidadPaginas > 5){
        if(pagina < 4){
            for (let i = 1; i <= 5; i++) {
                rango.push(i);            
            }
        }else{
            if(cantidadPaginas - pagina < 2){
                for (let i = cantidadPaginas-4; i <= cantidadPaginas; i++) {
                    rango.push(i);            
                }
            }else{
                for (let i = pagina-2; i <= pagina+2; i++) {
                    rango.push(i);            
                }
            }
        }
    }else{
        for (let i = 1; i <= cantidadPaginas; i++) {
            rango.push(i);            
        }
    }
    
    const EjecutarFuncion = (pag) => funcion(pag);

    return(
    <nav>
        <ul className="pagination justify-content-center">
            {/* PAGINA ANTERIOR */}
            {
                pagina == 1 ? (
                    <li className="page-item disabled">
                        <a className="page-link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-left-fill" viewBox="0 0 16 16">
                                <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
                            </svg>
                        </a>
                    </li>
                ) : (
                    <li className="page-item" onClick={e=>EjecutarFuncion(pagina-1)}>
                        <a className="page-link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-left-fill" viewBox="0 0 16 16">
                                <path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
                            </svg>
                        </a>
                    </li>
                )
            }

            {/* PAGINAS */}
            {rango.map((item, index)=>(
                <li key={index} className={item == pagina ? "page-item active" : "page-item"} onClick={item==pagina ? e=>{} : e=> EjecutarFuncion(item)}><a className="page-link">{item}</a></li>
            ))}

            {/* PAGINA SIGUIENTE */}
            {
                pagina == cantidadPaginas ? (
                    <li className="page-item disabled">
                        <a className="page-link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                            </svg>
                        </a>
                    </li>
                ) : (
                    <li className="page-item" onClick={e=>EjecutarFuncion(pagina+1)}>
                        <a className="page-link">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16">
                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
                            </svg>
                        </a>
                    </li>
                )
            }
        </ul>
    </nav>
    );
}